import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {Observable, of, ReplaySubject} from "rxjs";
import {Regional} from "../../../shared/interface/regional";
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {MatSnackBar} from "@angular/material/snack-bar";
import {Router} from "@angular/router";
import {FormHelperService} from "../../../shared/services/form-helper.service";
import {RegionalService} from "../../../shared/services/regional.service";
import {delay, first, takeUntil, tap} from "rxjs/operators";
import {Uuid} from "../../../shared/interface/response/uuid";
import {HttpErrorResponse} from "@angular/common/http";
import {UserPermissions} from "../../../shared/interface/user-permissions";
import {AuthService} from "../../../shared/services/auth.service";
import {validPhoneNumber} from '../../../shared/validator/phone-validator';

@Component({
  selector: 'app-regional-add',
  templateUrl: './regional-add.component.html',
  styleUrls: ['./regional-add.component.scss']
})
export class RegionalAddComponent implements OnInit, OnDestroy {
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);
  private initialized: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);
  userPermissions: ReplaySubject<UserPermissions>;

  @Input() regionalObject?: Regional;
  @Input() regional?: Observable<Regional>;
  @Output() closeModification = new EventEmitter<any>();
  @Output() regionalCreated = new EventEmitter<string>();

  userPermissionss: UserPermissions;
  regionalForm: FormGroup;
  formErrors: any = {};
  regionalFormValid = false;
  firstNameControl: FormControl;
  lastNameControl: FormControl;
  passwordControl: FormControl;
  deletedControl: FormControl;
  emailControl: FormControl;
  phoneControl: FormControl;
  accountUserControl: FormControl;
  processingRequest = false;
  constructor(
    private regionalService: RegionalService,
    private snackBar: MatSnackBar,
    private router: Router,
    private fb: FormBuilder,
    private formHelper: FormHelperService,
    private snack: MatSnackBar,
    private auth: AuthService,
  ) {
    this.userPermissions = this.auth.getUserPermissions();
    this.regionalForm = this.fb.group({
      firstName: this.firstNameControl = fb.control('', [Validators.required]),
      lastName: this.lastNameControl = fb.control('', [Validators.required]),
      password: this.passwordControl = fb.control('', [Validators.required]),
      deleted: this.deletedControl = fb.control(false, [Validators.required]),
      email: this.emailControl = this.fb.control('', [Validators.required, Validators.email]),
      phone: this.phoneControl = this.fb.control('', [Validators.required, validPhoneNumber()]),
      accountUser: this.accountUserControl = fb.control(''),
    });
  }

  ngOnInit(): void {
    this.auth.getUserPermissions()
      .subscribe((userPermissions: UserPermissions) => {
        this.userPermissionss = userPermissions;
      });
  this.regionalForm.valueChanges
    .pipe(takeUntil(this.destroyed$))
    .subscribe(() => this.regionalFormValid = this.regionalForm.valid);

  if (this.regional) {
      this.regional
        .pipe(takeUntil(this.destroyed$))
        .subscribe((regional: Regional) => {
          this.regionalObject = regional;
          this.initialize(regional);
        });
    } else {
      this.initialized.next(true);
    }
  }
  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  initialize(regional: Regional): void {
    of(regional)
      .pipe(
        delay(0),
        tap(() => {
          this.regionalForm.reset({
            firstName: regional.firstName,
            lastName: regional.lastName,
            password: regional.password,
            deleted: !regional.deleted,
            email: regional.email,
            phone: regional.phone,
            accountUser: regional.accountUser?.uuid,
          });
        }),
        delay(0),
        tap(() => this.initialized.next(true))
      ).subscribe();
  }
  save(): void {
    if (!this.regionalForm.valid) {
      this.regionalForm.markAllAsTouched();
      this.snack.open('Wypełnij lub popraw wszystkie wymagane pola', '', {
        duration: 2000,
      });
      return;
    }
    this.regionalService.sendForm(this.regionalForm.getRawValue(), this.regionalObject ? this.regionalObject.uuid : null
    )
      .pipe(
        first()
      )
      .subscribe((response: Uuid) => {
        this.snackBar.open(this.regionalObject ? 'Pomyślnie zaktualizowano regionalnego' : 'Pomyślnie utworzono regionalnego', '', {
          duration: 2000,
        });
        this.processingRequest = false;
        if (this.regional) {
          this.closeModification.emit();
        } else {
          this.router.navigate(['/uzytkownicy/regionalni/szczegoly', response.uuid]);
        }
      }, (error: HttpErrorResponse) => {

        this.snackBar.open('Podczas przesyłania formularza wystąpił błąd', error.status.toString(), {
          duration: 2000,
        });

        if (error.status === 400) {
          this.formErrors = error.error.error.list;
          this.formHelper.setBackendErrorState(this.regionalForm, this.formErrors);
        }
      });
  }

  cancel(): void {
    if (!this.regionalObject) {
      this.router.navigate(['/uzytkownicy/regionalni']);
    } else {
      this.closeModification.emit();
    }
  }
  generatePassword(): void{
    const randomstring = Math.floor(100000 + Math.random() * 900000);
    this.passwordControl.setValue(randomstring);
  }
}
